var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags"},[_c('ul',_vm._l((_vm.tags),function(tag,index){return _c('li',{key:index},[_c('a',{attrs:{"href":("" + _vm.address + (_vm.makeSlug(tag)))}},[_vm._v(_vm._s(tag))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52fc52b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleTags/ArticleTags.vue
// module id = null
// module chunks = 